import React from 'react';
import './Styles.css';
import AddressInheritanceCheckBox from './AddressInheritanceCheckBox';
import ExistingAddressSelector from './ExistingAddressSelector';
import { useGlobalAddressContext } from '../../../AddressInfo';
import { handleClick } from './AddressViewTopFunctions';
import { formatMessage } from '../../../../../../../../Localization/formatMessage';
import Messages from '../../../../../../../../Localization/Messages';
import { PresentationMode } from '../../../../../../../../Enums/PresentationMode';
import { useTeamPageContext } from '../../../../../../TeamPage';
import PrimaryButton from '../../../../../../../../Elements/ids/Buttons/PrimaryButton';

const AddressViewTop = () => {
  const {
    modalMode,
    isModalOpenedOnTeamLevel,
    addressState,
    agentCode,
    codePrefix,
    addressDispatch,
    setModalMode,
  } = useGlobalAddressContext();

  const { teamPageDispatch } = useTeamPageContext();

  return (
    <>
      {modalMode !== PresentationMode.Add && modalMode !== PresentationMode.Edit && (
        <>
          <div className="team-page_address-info_inheritance-container">
            <div className="team-page_address-info_inheritance-checkbox-container">
              <div>{!isModalOpenedOnTeamLevel && addressState.teamAddress && <AddressInheritanceCheckBox />}</div>
              <div>{isModalOpenedOnTeamLevel || !addressState.isInherited ? <ExistingAddressSelector /> : <></>}</div>
            </div>

            <PrimaryButton
              text={formatMessage(Messages.common_update)}
              onClickEvent={() => {
                handleClick(
                  agentCode,
                  codePrefix,
                  addressState,
                  addressDispatch,
                  setModalMode,
                  isModalOpenedOnTeamLevel,
                  teamPageDispatch
                );
              }}
              disabled={!addressState.topViewButtonState}
              isSmall={true}
            />
          </div>

          <div className="team-page_address-info_divider-line"></div>
        </>
      )}
    </>
  );
};

export default AddressViewTop;
